import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * DangerZone — destructive settings block used on Settings, Branding, etc.
 * Code-composed. Provides a red-bordered section with a title + description + action.
 */
export interface DangerZoneProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode
  description?: React.ReactNode
  action: React.ReactNode
}

export const DangerZone = React.forwardRef<HTMLDivElement, DangerZoneProps>(
  ({ className, title, description, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-md border border-ia-error/30 bg-ia-error-bg/50 p-4 flex items-center justify-between gap-4',
        className,
      )}
      {...props}
    >
      <div className="flex flex-col gap-1 min-w-0">
        <h3 className="text-body-md font-semibold text-ia-text">{title}</h3>
        {description && <p className="text-caption text-ia-text-secondary">{description}</p>}
      </div>
      <div className="shrink-0">{action}</div>
    </div>
  ),
)
DangerZone.displayName = 'DangerZone'
